import { SectionHeader, SectionWrap } from "@/components/Section";
import { Microscope, Activity, HeartPulse, Moon, FlaskConical } from "lucide-react";

const APPS = [
  {
    icon: Microscope,
    title: "Neurodegenerative research",
    body: "Future applications may include circuit-level monitoring frameworks that support neurodegenerative disease research workflows.",
    color: "#38BDF8",
  },
  {
    icon: Activity,
    title: "Motor rehabilitation",
    body: "Designed to support research into closed-loop interfaces aimed at paralysis and motor recovery contexts.",
    color: "#2563EB",
  },
  {
    icon: HeartPulse,
    title: "Adaptive biofeedback",
    body: "Platform direction includes adaptive biofeedback approaches that may help guide mental-health and resilience research.",
    color: "#6366F1",
  },
  {
    icon: Moon,
    title: "Sleep & wellness",
    body: "Built toward sensing and modeling frameworks that aim to enable richer sleep, recovery, and cognitive performance research.",
    color: "#8B5CF6",
  },
  {
    icon: FlaskConical,
    title: "Drug-response modeling",
    body: "Modeling concepts aimed to support drug-response and circuit-modeling experimentation in research settings.",
    color: "#38BDF8",
  },
];

export function ApplicationsSection() {
  return (
    <SectionWrap id="applications">
      <SectionHeader
        num="05"
        kicker="Applications"
        title="Built for the future of brain health and performance."
        sub="These are research-stage platform directions — not approved clinical claims. Each domain represents a future possibility for the Neurobolt closed-loop platform."
      />

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {APPS.map(({ icon: Icon, title, body, color }, i) => (
          <article
            key={i}
            className="reveal group glass rounded-3xl p-7 relative overflow-hidden hover:translate-y-[-4px] transition-all duration-500"
            style={{ transitionDelay: `${i * 50}ms` }}
          >
            <div
              className="absolute -top-16 -right-16 h-44 w-44 rounded-full opacity-30 group-hover:opacity-60 transition-opacity"
              style={{
                background: `radial-gradient(circle, ${color}55, transparent 65%)`,
              }}
            />
            <div
              className="h-12 w-12 rounded-xl grid place-items-center"
              style={{ background: `${color}1A`, color }}
            >
              <Icon size={20} strokeWidth={1.7} />
            </div>
            <h3 className="mt-6 font-display text-white text-[20px] font-medium">
              {title}
            </h3>
            <p className="mt-3 text-[#94A3B8] text-[14.5px] leading-relaxed">
              {body}
            </p>
            <div className="mt-7 font-mono text-[10px] uppercase tracking-[0.3em] text-[#475569]">
              future application direction
            </div>
          </article>
        ))}

        {/* Disclaimer card */}
        <article className="reveal relative rounded-3xl p-7 border border-dashed border-white/10 bg-[#040A18]/60">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#38BDF8]">
            Research disclosure
          </div>
          <p className="mt-4 text-[#CBD5E1] text-[14px] leading-relaxed">
            Neurobolt.AI does not claim to cure, treat, diagnose, reverse, or
            clinically validate outcomes. All applications listed are platform
            directions for future research.
          </p>
        </article>
      </div>
    </SectionWrap>
  );
}
